<template>
  <div class="addClassBox">
    <div class="addClassBoxIn">
      <div class="header">
        <span class="title">修改小程序检视账号</span>
        <i class="iconfont icon-guanbi" @click="close" />
      </div>
      <div class="item">
        <h6 class="secondTitle">用户名</h6>
        <el-input
          v-model="name"
          :maxlength="12"
          :minlength="4"
          type="text"
          placeholder="支持中文、字母、数字的组合，4-12个字符"
          class="input"
          @input="nameInput"
        />
        <p v-if="isSubmit && !testname" class="prompt">
          <i v-if="!name.trim()" class="text">请输入用户名</i>
          <i v-else class="text">仅支持中文、字母、数字的组合，4-12个字符</i>
        </p>
        <p v-else class="prompt" />
      </div>
      <div class="item">
        <h6 class="secondTitle">密码</h6>
        <el-input
          v-model="password"
          :maxlength="12"
          :minlength="4"
          type="text"
          placeholder="支持字母、数字的组合，4-12个字符"
          class="input"
          @input="passInput"
        />
        <p v-if="isSubmit && !testpassword" class="prompt">
          <i v-if="!password.trim()" class="text">请输入密码</i>
          <i v-else class="text">仅支持字母、数字的组合，4-12个字符</i>
        </p>
        <p v-else class="prompt" />
      </div>
      <el-button class="comfirmButton" type="primary" size="medium" @click="submit">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddExaminAccount',
  props: {
    accountName: String,
    accountPassWord: String,
  },
  data() {
    return {
      nameRegE: /^[\u4e00-\u9fa5a-zA-Z0-9]{4,12}$/ /* 用户名正则表达式 */,
      passRegE: /^[a-zA-Z0-9]{4,12}$/ /* ,密码正则表达式 */,
      name: '' /* 用户名 */,
      password: '' /* 密码 */,
      testname: true /* 用户名校验结果 */,
      testpassword: true /* 密码校验结果 */,
      isSubmit: false /* 是否触发提交 */,
    };
  },
  watch: {
    accountName: {
      handler(value) {
        this.name = value;
      },
      immediate: true,
    },
    accountPassWord: {
      handler(value) {
        this.password = value;
      },
      immediate: true,
    },
  },
  methods: {
    nameInput(val) {
      if (this.isSubmit) {
        this.testname = this.nameRegE.test(val.trim());
      }
    },
    passInput(val) {
      if (this.isSubmit) {
        this.testpassword = this.passRegE.test(val.trim());
      }
    },
    close() {
      this.$emit('hideDialog');
    },
    submit() {
      /* 提交 */
      this.isSubmit = true;
      this.testname = this.nameRegE.test(this.name.trim());
      this.testpassword = this.passRegE.test(this.password.trim());
      if (this.testname && this.testpassword) {
        this.$emit('saveNamePassword', {
          name: this.name,
          password: this.password,
        });
        this.close();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
